'use strict';
(() => {
  if (!document.body.classList.contains('gv-store')) return;
  const menu = document.getElementById('gv-menu');
  document.querySelector('[data-gv-menu]')?.addEventListener('click', () => menu.showModal());
  document.querySelector('[data-gv-close]')?.addEventListener('click', () => menu.close());
  menu?.addEventListener('click', event => { if (event.target === menu && event.offsetX < 0) menu.close(); });
  const input = document.getElementById('gv-quantity');
  document.querySelectorAll('[data-gv-quantity]').forEach(button => button.addEventListener('click', () => {
    input.value = Math.max(1, Math.min(99, (Number(input.value) || 1) + Number(button.dataset.gvQuantity)));
    input.dispatchEvent(new Event('change', {bubbles:true}));
  }));
  const templates = Array.from(document.querySelectorAll('template[data-gv-slide]'));
  const stage = document.getElementById('gallery-stage');
  let current = 0;
  function show(index) {
    current = (index + templates.length) % templates.length;
    stage.replaceChildren(templates[current].content.cloneNode(true));
    document.getElementById('gallery-caption').textContent = templates[current].dataset.gvCaption;
    document.querySelectorAll('[data-slide]').forEach(el => el.setAttribute('aria-pressed', Number(el.dataset.slide) === current));
    const selected = document.querySelector(`[data-slide="${current}"]`);
    const strip = document.querySelector('.gallery-thumbs');
    strip.scrollTo({left:selected.offsetLeft-strip.offsetLeft-strip.clientWidth/2+selected.clientWidth/2, behavior:'smooth'});
  }
  document.querySelectorAll('[data-slide]').forEach(button => button.addEventListener('click', () => show(Number(button.dataset.slide))));
  document.querySelector('[data-action="previous"]')?.addEventListener('click', () => show(current-1));
  document.querySelector('[data-action="next"]')?.addEventListener('click', () => show(current+1));
  const sticky = document.getElementById('sticky-buy');
  if (sticky) new IntersectionObserver(entries => {
    const visible = !entries[0].isIntersecting && entries[0].boundingClientRect.bottom < 0;
    sticky.classList.toggle('visible',visible);
    sticky.inert = !visible;
    sticky.setAttribute('aria-hidden',String(!visible));
  }, {threshold:0}).observe(document.getElementById('purchase'));
  const form = document.getElementById('gv-product-form');
  form?.addEventListener('submit', async event => {
    if (!window.fetch) return;
    event.preventDefault();
    const error = document.getElementById('gv-cart-error');
    const buttons = document.querySelectorAll('[form="gv-product-form"], #gv-product-form button[type="submit"]');
    error.hidden = true;
    buttons.forEach(el => {el.disabled=true; el.setAttribute('aria-busy','true');});
    try {
      const response = await fetch(window.routes.cart_add_url + '.js', {method:'POST', body:new FormData(form), headers:{Accept:'application/json'}});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || window.cartStrings.error);
      window.location.assign(window.routes.cart_url);
    } catch (problem) {
      error.textContent=problem.message;
      error.hidden=false;
      buttons.forEach(el => {el.disabled=false; el.removeAttribute('aria-busy');});
    }
  });
})();
